import { Link, Outlet, useNavigate, useSearchParams } from "react-router-dom";
import {
  ArrowLeft,
  BarChart3,
  GitCompare,
  GraduationCap,
  LineChart,
  MapPin,
  ShieldAlert,
  Target,
  Users,
} from "lucide-react";
import { GER_NAV_ITEMS } from "@/components/ger/gerConstants";
import ScopeFilter from "@/components/ScopeFilter";
import SidebarUserCard from "@/components/SidebarUserCard";
import { ScopeProvider } from "@/context/ScopeContext";
import "../pages/GerDashboard.css";
import "../styles/sqafSidebarShell.css";
import "./DashboardTopBar.css";

const SIDEBAR_ICONS = {
  overview: BarChart3,
  stage: LineChart,
  district: MapPin,
  gender: Users,
  transition: GitCompare,
  population: GraduationCap,
  risk: ShieldAlert,
  action: Target,
};

const StandaloneGerLayout = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "overview";

  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate("/login");
  };

  const goToTab = (tabId) => {
    const next = new URLSearchParams(searchParams);
    if (tabId === "overview") next.delete("tab");
    else next.set("tab", tabId);
    navigate({ pathname: "/ger-dashboard", search: next.toString() ? `?${next.toString()}` : "" });
  };

  return (
    <ScopeProvider>
    <div className="ger-dashboard-root">
      <div className="app-shell">
        <aside className="sq-sidebar" aria-label="GER dashboard sidebar">
          <div className="sq-sidebar-brand">
            <Link className="sq-sidebar-brand-main" to="/" style={{ textDecoration: "none", color: "inherit" }}>
              <span className="sq-brand-icon" aria-hidden="true">
                <GraduationCap strokeWidth={2} width={22} height={22} />
              </span>
              <span className="sq-brand-copy">
                <strong>MH Education</strong>
                <span>GER Dashboard 2025–26</span>
              </span>
            </Link>
          </div>

          <div className="sq-sidebar-scroll">
            <section className="sq-sidebar-section">
              <div className="sq-section-title">GER Views</div>
              <nav className="sq-nav">
                {GER_NAV_ITEMS.map(({ id, label }) => {
                  const Icon = SIDEBAR_ICONS[id] || BarChart3;
                  return (
                    <button
                      key={id}
                      type="button"
                      className={`sq-nav-item${activeTab === id ? " active" : ""}`}
                      onClick={() => goToTab(id)}
                    >
                      <Icon strokeWidth={2} />
                      {label}
                    </button>
                  );
                })}
              </nav>
            </section>
          </div>

          <div className="sq-sidebar-footer">
            <SidebarUserCard user={user} onLogout={handleLogout} />
          </div>
        </aside>

        <main className="main">
          <header className="topbar">
            <div className="topbar-inner">
              <div className="breadcrumb">
                <Link to="/">Maharashtra</Link>
                <span>›</span>
                <b>GER Dashboard</b>
              </div>
              <div className="top-actions">
                <ScopeFilter variant="chip" />
                <span className="filter-chip">
                  Year <b>2025–26</b>
                </span>
                <Link to="/" className="icon-button" title="Back to landing" style={{ textDecoration: "none", display: "grid", placeItems: "center" }}>
                  <ArrowLeft strokeWidth={2} width={18} height={18} />
                </Link>
              </div>
            </div>
          </header>
          <Outlet context={{ user, activeTab }} />
        </main>
      </div>
    </div>
    </ScopeProvider>
  );
};

export default StandaloneGerLayout;
